import React from 'react';
import { Controller } from 'react-hook-form';
import { FormFeedback, Input } from 'reactstrap';
import { CLAIM_FORM_TYPES } from '../../../pages/ExpenseClaims/Employee/EmployeeExpenseClaim/constants';

export default function NoOfIndividualsElement({
  formMethods,
  name,
  formType,
}) {
  const {
    control,
    formState: { errors },
  } = formMethods;
  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Input
            {...field}
            type="number"
            name={name}
            placeholder="No. Of Individuals"
            className={`form-control external-filter-input ${errors?.[name] ? 'is-invalid' : ''}`}
            disabled={formType === CLAIM_FORM_TYPES.VIEW}
            title="No. Of Individuals"
          />
        )}
      />
      {errors?.[name] && <FormFeedback>{errors?.[name]?.message}</FormFeedback>}
    </>
  );
}
